__turbopack_context__.v({
  "carousel-card": "K7MlxG_carousel-card",
  "carousel-card--highlighted": "K7MlxG_carousel-card--highlighted",
  "carousel-card__action": "K7MlxG_carousel-card__action",
  "carousel-card__badge": "K7MlxG_carousel-card__badge",
  "carousel-card__content": "K7MlxG_carousel-card__content",
  "carousel-card__content-description": "K7MlxG_carousel-card__content-description",
  "carousel-card__content-description--line-clamp-2": "K7MlxG_carousel-card__content-description--line-clamp-2",
  "carousel-card__content-description--line-clamp-3": "K7MlxG_carousel-card__content-description--line-clamp-3",
  "carousel-card__content-description--line-clamp-no-children": "K7MlxG_carousel-card__content-description--line-clamp-no-children",
  "carousel-card__content-headline": "K7MlxG_carousel-card__content-headline",
  "carousel-card__footer": "K7MlxG_carousel-card__footer",
  "carousel-card__footer-action": "K7MlxG_carousel-card__footer-action",
  "carousel-card__image": "K7MlxG_carousel-card__image",
  "carousel-card__image-container": "K7MlxG_carousel-card__image-container",
});
